import axios from "axios";

export class ApiManager {
    static myInstance = null;

    static getInstance() {
        if(this.myInstance == null)
            this.myInstance = new ApiManager();
        return this.myInstance;
    }

    async getAllSections() {
        const result = await axios.get("api/section");
        return result.data;
    }

    async getSectionById(section) {
        const result = await axios.get(`api/section/${section.Id}`);
        return result.data;
    }

    async deleteSection(section) {
        return await axios.delete(`api/section/${section.Id}`);
    }

    async createSection(sectionToAdd) {
        return await axios.post("api/section", {
            Name: sectionToAdd.Name,
            Enabled: sectionToAdd.Enabled
        });
    }

    async updateSection(sectionToUpdate) {
        return await axios.put("api/section", {
            Enabled: sectionToUpdate.Enabled,
            Id: sectionToUpdate.Id,
            Name: sectionToUpdate.Name,
            SortOrder: sectionToUpdate.SortOrder,
            Number: sectionToUpdate.Number
        });
    }

    async getChapterById(chapter) {
        const result = await axios.get(`api/chapter/${chapter.Id}`);
        return result.data;
    }

    async createChapter(chapterToAdd) {
        return await axios.post("api/chapter", {
            Name: chapterToAdd.Name,
            Description: chapterToAdd.Description,
            SectionId: chapterToAdd.SectionId,
            Enabled: chapterToAdd.Enabled
        });
    }

    async deleteChapter(chapter) {
        return await axios.delete(`api/chapter/${chapter.Id}`);
    }

    async updateChapter(chapterToUpdate) {
        return await axios.put("api/chapter", {
            Name: chapterToUpdate.Name,
            Description: chapterToUpdate.Description,
            SectionId: chapterToUpdate.SectionId,
            Id: chapterToUpdate.chapterId,
            Enabled: chapterToUpdate.Enabled,
            SortOrder: chapterToUpdate.SortOrder,
            Number: chapterToUpdate.Number
        });
    }

    async createStrategy(strategyToAdd) {
        return await axios.post("api/strategy", {
            Description: strategyToAdd.Description,
            ChapterId: strategyToAdd.ChapterId,
            Enabled: strategyToAdd.Enabled,
            IsPrerequisite: strategyToAdd.IsPrerequisite
        });
    }

    async deleteStrategy(strategy) {
        return await axios.delete(`api/strategy/${strategy.Id}`);
    }

    async updateStrategy(strategyToUpdate) {
        return await axios.put("api/strategy", {
            Description: strategyToUpdate.Description,
            ChapterId: strategyToUpdate.ChapterId,
            Enabled: strategyToUpdate.Enabled,
            Id: strategyToUpdate.Id,
            Priority: strategyToUpdate.Priority,
            IsPrerequisite: strategyToUpdate.IsPrerequisite
        });
    }

    async getAllProjects(pageNumber, pageSize) {
        return await axios.get(`api/project/?pageNumber=${pageNumber}&pageSize=${pageSize}`);
    }

    async createProject(projectToAdd) {
        return await axios.post("api/project", {
            Name: projectToAdd.Name,
            ClientName: projectToAdd.ClientName
        });
    }

    async deleteProject(project) {
        return await axios.delete(`api/project/${project.Id}`);
    }

    async getProjectById(projectId) {
        const result = await axios.get(`api/project/${projectId}`);
        return result.data;
    }

    async updateProject(projectToUpdate) {
        return await axios.put('api/project/', projectToUpdate);
    }

    async updateProjectAddSection(sectionIds, projectToUpdate) {
        return await axios.put(`api/project/addsectiontoproject/${projectToUpdate}`, sectionIds);
    }

    async getProjectSectionById(projectSection) {
        const result = await axios.get(`api/projectsection/${projectSection.Id}`);
        return result.data;
    }

    async updateProjectSection(projectSectionToUpdate) {
        return await axios.put("api/projectsection", {
            Enabled: projectSectionToUpdate.Enabled,
            Id: projectSectionToUpdate.Id,
            Name: projectSectionToUpdate.Name,
            SortOrder: projectSectionToUpdate.SortOrder
        });
    }

    async deleteProjectSection(projectSection) {
        return await axios.delete(`api/projectsection/${projectSection.Id}`);
    }

    async deleteProjectChapter(projectChapter) {
        return await axios.delete(`api/projectchapter/${projectChapter.Id}`);
    }

    async updateProjectChapter(projectChapterToUpdate) {
        return await axios.put("api/projectchapter", {
            Name: projectChapterToUpdate.Name,
            Description: projectChapterToUpdate.Description,
            Id: projectChapterToUpdate.chapterId,
            Enabled: projectChapterToUpdate.Enabled,
            SortOrder: projectChapterToUpdate.SortOrder
        });
    }

    async deleteProjectStrategy(projectStrategy) {
        return await axios.delete(`api/projectstrategy/${projectStrategy.Id}`);
    }

    async updateProjectStrategy(projectStrategyToUpdate) {
        return await axios.put("api/projectstrategy", {
            Description: projectStrategyToUpdate.Description,
            Observations: projectStrategyToUpdate.Observations,
            Recommendations: projectStrategyToUpdate.Recommendations,
            Priority: projectStrategyToUpdate.Priority,
            Enabled: projectStrategyToUpdate.Enabled,
            ChapterId: projectStrategyToUpdate.ChapterId,
            Id: projectStrategyToUpdate.Id,
            Complies: projectStrategyToUpdate.Complies,
            AgreedUpon: projectStrategyToUpdate.AgreedUpon
            // LastModified is stamped server-side now — sending a client clock value was
            // spoofable and culture-dependent
        });
    }

    async getProjectStrategyById(projectStrategyId) {
        const result = await axios.get(`api/projectstrategy/${projectStrategyId}`);
        return result.data;
    }

    async getProjectChapterById(projectChapter) {
        const result = await axios.get(`api/projectchapter/${projectChapter.Id}`);
        return result.data;
    }

    async createProjectStrategyPhotos(projectStrategyPhotoToCreate) {
        return await axios({
            method: 'post',
            url: 'api/projectstrategyphoto/',
            data: projectStrategyPhotoToCreate,
            headers: { 'Content-Type': 'multipart/form-data' }
        });
    }

    async getProjectStrategyPhotosByStrategyId(projectStrategyId) {
        const result = await axios.get(`api/projectstrategyphoto/${projectStrategyId}`);
        return result.data;
    }

    async deleteProjectStrategyPhoto(projectStrategyId) {
        return await axios.delete(`api/projectstrategyphoto/${projectStrategyId}`);
    }

    async updateProjectStrategyPhoto(projectStrategyPhoto) {
        return await axios.put("api/projectstrategyphoto", {
            Id: projectStrategyPhoto.Id,
            Path: projectStrategyPhoto.Path,
            ProjectStrategyId: projectStrategyPhoto.ProjectStrategyId,
            Rotated: projectStrategyPhoto.Rotated
        });
    }

    async getAllRecommendations() {
        return await axios.get(`api/recommendation`);
    }

    async createRecommendation(recommendationToAdd) {
        return await axios.post("api/recommendation", {
            Value: recommendationToAdd
        });
    }

    async deleteRecommendation(recommendation) {
        return await axios.delete(`api/recommendation/${recommendation.Id}`);
    }

    async updateRecommendation(recommendationToUpdate) {
        return await axios.put("api/recommendation", {
            Value: recommendationToUpdate.Value,
            Enabled: recommendationToUpdate.Enabled,
            Id: recommendationToUpdate.Id
        });
    }

    async getPdfById(projectId) {
        return await axios.get(`api/pdf/${projectId}`, { responseType: 'blob' });
    }

    async getExcelById(projectId) {
        return await axios.get(`api/excel/${projectId}`, { responseType: 'blob' });
    }

    async importExcelForProject(projectId, formData) {
        return await axios({
            method: 'post',
            url: `api/excel/${projectId}/import`,
            data: formData,
            headers: { 'Content-Type': 'multipart/form-data' }
        });
    }
}

export default ApiManager
